const PACKAGE_VALIDITY_PREFIX_PATTERN = /^\s*(?:[-*]\s*)?(?:inclusions valid for|packages? valid for)\b/i
const PACKAGE_VALIDITY_GUEST_PATTERN = /\b(?:\d+|one|two|three|four|five|six|seven|eight|nine|ten|guest|guests|person|people|adult|adults|child|children|infant|infants|teenager|teenagers)\b/i
const INLINE_LIST_SEPARATOR_PATTERN = /\s+-\s+/

function isManualPackageValidityText(description: string): boolean {
  return PACKAGE_VALIDITY_PREFIX_PATTERN.test(description) && PACKAGE_VALIDITY_GUEST_PATTERN.test(description)
}

function getDescriptionWithoutManualPackageValidityText(description: string): string | undefined {
  if (isManualPackageValidityText(description)) {
    return undefined
  }

  const descriptionParts = description.split(INLINE_LIST_SEPARATOR_PATTERN)

  if (descriptionParts.length === 1) {
    return description
  }

  const visibleDescriptionParts = descriptionParts.filter(descriptionPart => !isManualPackageValidityText(descriptionPart))

  if (visibleDescriptionParts.length === descriptionParts.length) {
    return description
  }

  if (!visibleDescriptionParts.length) {
    return undefined
  }

  return visibleDescriptionParts.join(' - ')
}

export function getInclusionsWithoutPackageValidityText(
  inclusions: Array<App.PackageInclusion>,
  shouldRemovePackageValidityText: boolean,
): Array<App.PackageInclusion> {
  if (!shouldRemovePackageValidityText || !inclusions.length) {
    return inclusions
  }

  let hasChanges = false
  const visibleInclusions = inclusions.flatMap((inclusion) => {
    const description = getDescriptionWithoutManualPackageValidityText(inclusion.description)

    if (description === inclusion.description) {
      return [inclusion]
    }

    hasChanges = true

    if (!description) {
      return []
    }

    return [{ ...inclusion, description }]
  })

  return hasChanges ? visibleInclusions : inclusions
}
